<template>
  <div class="left-panel-layout">
    <slot name="map">map</slot>
    <app-toolbar
      v-model="selectedTabRef"
      class="left-panel-layout__app-toolbar"
      :items="tabs"
    />
    <left-panel-drawer
      class="left-panel-layout__left-panel"
      :is-open="isLeftPanelOpen"
    >
      <slot name="left-panel">left-panel</slot>
    </left-panel-drawer>
    <panel v-if="false" class="layout__right-panel">
      <slot name="right-panel">right-panel</slot>
    </panel>
    <!-- <div class="layout__bottom-panel">
      <slot name="bottom-panel">bottom-panel</slot>
    </div> -->
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import AppToolbar from '../app-toolbar'
import LeftPanelDrawer from '../left-panel-drawer'
import Panel from '../panel'
const props = defineProps({
  isLeftPanelOpen: Boolean,
  tabs: Array,
  selectedTab: String
})
const emit = defineEmits(['update:selectedTab'])
const selectedTabRef = ref(props.selectedTab)
watch(selectedTabRef, newVal => {
  emit('update:selectedTab', newVal)
})
</script>

<style lang="scss" scoped>
.left-panel-layout {
  position: relative;
  width: 100vw;
  height: 100vh;
  &__left-panel {
    position: absolute;
    background-color: lightblue;
    z-index: 100;
    top: 0;
    left: 60px;
  }
  &__right-panel {
    position: absolute;
    width: 300px;
    background-color: lightblue;
    z-index: 100;
    top: 0;
    right: 60px;
  }
  &__app-toolbar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 200;
  }
}
</style>
